import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import useSWR from "swr";
import fetcher from "../../utils/fetcher";
import { addProduct, removeProduct } from "../../redux/wishSlice";
import ProductImage from "../ProductImage";
import HomeCarousel from "./HomeCarousel";
import { FiHeart } from "react-icons/fi";
import styles from "../../styles/home.module.css";

// Shows best sellers by default, or the products of the selected category
const BestSellersSection = ({ categoryId = null, title = "الأكثر مبيعاً" }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const wishlist = useSelector((state) => state.wishlist.wishlist);

  const url = categoryId
    ? `${process.env.REACT_APP_BACKEND_URL}/api/products/category?categoryId=${categoryId}&page=1&limit=10`
    : `${process.env.REACT_APP_BACKEND_URL}/api/products/bestselling?page=1&limit=10`;

  const { data, isLoading } = useSWR(
    url,
    fetcher,
    {
      keepPreviousData: true,
      revalidateOnFocus: false,
      revalidateIfStale: true,
      shouldRetryOnError: (err) => err.status !== 304,
      errorRetryCount: 2,
      dedupingInterval: 10000,
    }
  );

  const products = data?.products || [];
  const lowestPrices = data?.lowestPrices || [];

  // Hide only while nothing has loaded yet; an empty category shows a message instead
  if (!data && !categoryId) return null;

  const isWished = (product) =>
    wishlist.some((item) => item.product.product_id === product.product_id);

  const toggleWish = (e, product, lowestPrice) => {
    e.stopPropagation();
    if (isWished(product)) {
      dispatch(removeProduct(product));
    } else {
      dispatch(addProduct({ product, lowestPrice }));
    }
  };

  return (
    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>{title}</h2>

      {!products.length ? (
        !isLoading && <p className={styles.emptyText}>لا توجد منتجات في هذا التصنيف حالياً</p>
      ) : (
        <HomeCarousel key={categoryId ?? "bestselling"}>
          {products.map((product) => {
            const lowestPrice = lowestPrices.find(
              (p) => p.product_id === product.product_id
            )?.min_price;

            return (
              <div
                key={product.product_id}
                className={styles.card}
                onClick={() => navigate(`/product/${product.product_id}`)}
              >
                <div className={styles.cardImg}>
                  <ProductImage url={product.image_url} alt={product.name} loading="lazy" />

                  <button
                    type="button"
                    aria-label="أضف للمفضلة"
                    className={styles.cardWish}
                    onClick={(e) => toggleWish(e, product, lowestPrice)}
                  >
                    <FiHeart style={{ fill: isWished(product) ? "#a8825c" : "none" }} />
                  </button>
                </div>

                <div className={styles.cardBody}>
                  <p className={styles.cardTitle}>{product.name}</p>
                  {lowestPrice && (
                    <div className={styles.cardPrice}>يبدأ من {lowestPrice} ₪</div>
                  )}
                </div>
              </div>
            );
          })}
        </HomeCarousel>
      )}
    </section>
  );
};

export default BestSellersSection;
